import { SubdomainPerTypeDto, type SubdomainPerTypeInterface } from '@zaoblako/shared/modules/saas/dtos/subdomain/subdomain-per-type.dto';
import { TakenSubdomainTypeEnum } from '@zaoblako/shared/modules/saas/enums/taken-subdomain-type.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';
import { mapSchema } from '@zaoblako/shared/modules/serde/schemas/map.schema';

import * as yup from 'yup';

/** Aggregated tenant subdomains - DTO signature */
export interface TenantSubdomainsInterface {
  /** Subdomains used by tenant by type */
  subdomainsByType: SubdomainPerTypeInterface;
  /** Tenant used subdomain types by subdomain ("inverted" {@link TenantSubdomainsInterface.subdomainsByType} value) */
  typesBySubdomain: Record<string, TakenSubdomainTypeEnum>;
}

/** Aggregated tenant subdomains - DTO schema */
export const TenantSubdomainsDto = SerdeDtoClass.create<TenantSubdomainsInterface>(SaasDtoKeysEnum.TENANT_SUBDOMAINS_DTO, {
  subdomainsByType: {
    label: 'Поддомены по типам',
    nested: SubdomainPerTypeDto as any,
    serializer: (_, nested) => nested as any,
  },
  typesBySubdomain: {
    label: 'Типы по поддоменам',
    serializer: mapSchema(
      yup.string(),
      yup
        .string()
        .oneOf(Object.values(TakenSubdomainTypeEnum)),
    ),
  },
});
